// extracted by mini-css-extract-plugin
export default {"facetMenu":"wB-z","fixed":"xB-z","nonLayerdFacets":"yB-z","productCount":"zB-z","facetBack":"AB-z","arrow":"BB-z","facetClose":"CB-z"};